import RCModal from './RCModal';

export default RCModal;
